module.exports = __webpack_public_path__ + "sc.svg?5d8966f42246b186ca5ef3d2144ba158";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/sc.svg
// module id = 1343
// module chunks = 0